import React from "react";
import { StatusBadgeColorConfig } from "../../../shared/themes/redesignTokens";
import RedesignStatusBadge from "../../../shared/components/redesign/RedesignStatusBadge";
import { WorkOrderStatusCode } from "../models/models";
import useTranslation from "../../../shared/hooks/useTranslation";

export const woStatusColors: Record<number, StatusBadgeColorConfig> = {
  [WorkOrderStatusCode.Created]: { bg: "#F4F6F9", text: "#6B7280", border: "#D1D5DB" },
  [WorkOrderStatusCode.Assigned]: { bg: "#EEF2F7", text: "#546E7A", border: "#B0BEC5" },
  [WorkOrderStatusCode.Scheduled]: { bg: "#EBF5FB", text: "#2980B9", border: "#AED6F1" },
  [WorkOrderStatusCode.InProgress]: { bg: "#FFF3E0", text: "#B8860B", border: "#FFE082" },
  [WorkOrderStatusCode.OnHold]: { bg: "#FFF3E0", text: "#E67E22", border: "#FFCC80" },
  [WorkOrderStatusCode.Completed]: { bg: "#EAFAF1", text: "#27AE60", border: "#ABEBC6" },
  [WorkOrderStatusCode.Verified]: { bg: "#E8F5E9", text: "#1B5E20", border: "#A5D6A7" },
  [WorkOrderStatusCode.Cancelled]: { bg: "#FDEDEC", text: "#E74C3C", border: "#F5B7B1" },
  [WorkOrderStatusCode.PendingReview]: { bg: "#F3EEFF", text: "#7C3AED", border: "#D4BBFF" },
};

export const statusTranslationKeys: Record<number, string> = {
  [WorkOrderStatusCode.Created]: "statuses.created",
  [WorkOrderStatusCode.Assigned]: "statuses.assigned",
  [WorkOrderStatusCode.Scheduled]: "statuses.scheduled",
  [WorkOrderStatusCode.InProgress]: "statuses.inProgress",
  [WorkOrderStatusCode.OnHold]: "statuses.onHold",
  [WorkOrderStatusCode.Completed]: "statuses.completed",
  [WorkOrderStatusCode.Verified]: "statuses.verified",
  [WorkOrderStatusCode.Cancelled]: "statuses.cancelled",
  [WorkOrderStatusCode.PendingReview]: "statuses.pendingReview",
};

interface WorkOrderStatusBadgeProps {
  statusId: number;
  statusName?: string;
  size?: "sm" | "lg";
}

const WorkOrderStatusBadge = ({ statusId, statusName, size }: WorkOrderStatusBadgeProps) => {
  const { translate } = useTranslation("operations");
  const colorConfig = woStatusColors[statusId] || woStatusColors[WorkOrderStatusCode.Created];
  const key = statusTranslationKeys[statusId];
  const label = key ? translate(key) : (statusName || translate("common:unknown"));

  return <RedesignStatusBadge label={label} colorConfig={colorConfig} size={size} />;
};

export default WorkOrderStatusBadge;
